import { useNavigate } from "react-router-dom";
import { homepageData } from "@/mocks/homeData";

export default function Footer() {
  const navigate = useNavigate();
  const { footer } = homepageData;

  return (
    <footer className="bg-foreground-950 text-background-200">
      <div className="page-container py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
          {/* Column 1: Brand */}
          <div className="min-w-0">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://storage.readdy-site.link/project_files/6517ebfd-0186-45e8-a53b-6a7dda87aef3/6d23f5d8-f2c4-4070-a39b-51782f265262_compressed_logo-02.webp"
                alt="千華駐科技"
                className="h-7 w-auto object-contain invert flex-shrink-0"
              />
              <span className="font-heading font-semibold text-lg text-background-100 tracking-wide">
                千華駐科技出版有限公司
              </span>
            </div>
            <p className="text-sm text-background-300/80 leading-relaxed mb-3">
              {footer.brandSummary}
            </p>
            <p className="text-xs text-background-400/60 leading-relaxed">
              {footer.description}
            </p>
          </div>

          {/* Column 2: Internal Navigation */}
          <div className="min-w-0">
            <h4 className="font-heading font-semibold text-background-100 text-sm mb-4 tracking-wide">
              網站導覽
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footer.internalLinks.map((link) => (
                <li key={link.href}>
                  <button
                    onClick={() => {
                      window.scrollTo(0, 0);
                      navigate(link.href);
                    }}
                    className="text-sm text-background-300/70 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: External Links - 3-site interconnection */}
          <div className="min-w-0">
            <h4 className="font-heading font-semibold text-background-100 text-sm mb-4 tracking-wide">
              相關網站
            </h4>
            <ul className="flex flex-col gap-4">
              {footer.externalLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="nofollow noopener"
                    className="group block transition-colors cursor-pointer"
                  >
                    <span className="text-sm text-background-300/70 group-hover:text-background-100 transition-colors inline-flex items-center gap-1.5 whitespace-nowrap">
                      {link.label}
                      <i className="ri-external-link-line text-[10px] opacity-60 group-hover:opacity-100 transition-opacity" />
                    </span>
                    {link.description && (
                      <span className="block text-xs text-background-400/50 mt-1 leading-relaxed">
                        {link.description}
                      </span>
                    )}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-400/10">
        <div className="page-container py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400/50">
            &copy; {new Date().getFullYear()} 千華駐科技出版有限公司．All Rights Reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://www.books.com.tw/web/sys_puballb/books/?pubid=qianhua1"
              target="_blank"
              rel="nofollow noopener"
              className="text-xs text-background-400/50 hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap"
            >
              博客來品牌書目
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}